var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "9px",
    viewBox: "0 0 42 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "genie") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.762449%",
    y1: "1.12050953%",
    x2: "52.762449%",
    y2: "101.024784%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8300",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF000F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.2814074%",
    y1: "-0.120182989%",
    x2: "50.2814074%",
    y2: "99.8720638%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8300",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF000F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.1603298%",
    y1: "-0.209117524%",
    x2: "50.1603298%",
    y2: "99.832706%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8300",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF000F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-0.209205021%",
    x2: "50%",
    y2: "99.874477%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8300",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF000F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.171835%",
    y1: "-0.120183851%",
    x2: "50.171835%",
    y2: "99.8727801%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8300",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF000F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "87.8283979%",
    y1: "48.608429%",
    x2: "45.542716%",
    y2: "48.608429%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59017",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBD46",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.4161566%",
    y1: "48.608429%",
    x2: "15.9971744%",
    y2: "48.608429%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F90A0A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD2647",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "83.5520217%",
    y1: "47.7585335%",
    x2: "26.0212848%",
    y2: "47.7585335%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF271E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8200",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-designs-1.1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13.-home",
    transform: "translate(-39, -462)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "genie",
    transform: "translate(39.8699, 462.0061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Genie-Font",
    transform: "translate(9.7449, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.40340494,8.99960769 C5.933117,8.99960769 6.99525344,7.87751193 6.99525344,5.57336111 L6.99525344,0 L5.61047878,0.285520548 C5.33755508,0.312004394 5.12508361,0.534188851 5.11081782,0.808023152 L5.11081782,1.10781973 C4.60677395,0.404490755 3.7826026,0.00206333817 2.91802001,0.0371176713 C1.35907781,0.0485384932 0,1.24486959 0,3.14072603 C0,5.03658247 1.33338096,6.25575522 2.9665585,6.25575522 C3.82895201,6.27818239 4.64505533,5.8663773 5.13936987,5.15935631 L5.13936987,5.73039741 C5.13936987,6.88961083 4.4798174,7.52632166 3.24636864,7.52632166 C2.45216777,7.50432593 1.67440472,7.29496581 0.976480276,6.91530768 L0.976480276,7.9117744 C0.976480276,8.34862084 1.00217713,8.39715933 1.43616836,8.59702371 C2.05536297,8.87103211 2.72634791,9.00834543 3.40340494,8.99960769 Z M3.46621946,4.77390357 C3.02902857,4.79117389 2.60464061,4.62426454 2.29634631,4.31379914 C1.988052,4.00333375 1.82412488,3.57778496 1.84446274,3.14072603 C1.82412488,2.7036671 1.988052,2.27811831 2.29634631,1.96765292 C2.60464061,1.65718753 3.02902857,1.49027817 3.46621946,1.5075485 C3.89952519,1.49587358 4.31806313,1.66546331 4.6210247,1.97547049 C4.92398626,2.28547767 5.08391089,2.70780314 5.06227932,3.14072603 C5.07630471,3.57156239 4.91388977,3.9894609 4.61260453,4.29775278 C4.31131929,4.60604465 3.89726437,4.77802227 3.46621946,4.77390357 L3.46621946,4.77390357 Z",
    id: "path-2-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.0724869,0.0770905481 C9.07384303,0.0770905481 7.81184221,1.61890151 7.81184221,3.66608384 C7.81184221,5.66472768 9.09953988,7.20082823 11.2580752,7.20082823 C11.9920958,7.22979831 12.7216132,7.07368355 13.3794929,6.74685056 C13.7249728,6.55269659 13.7392488,6.51272371 13.7392488,6.06160124 L13.7392488,5.0508585 C13.0504767,5.42177132 12.2829412,5.62246619 11.5007677,5.63617563 C10.7184414,5.63617563 9.81334125,5.18219795 9.70198824,4.20857288 L14.3274211,4.20857288 C14.4816022,1.95867096 13.4194658,0.0770905481 11.0724869,0.0770905481 Z M9.67058098,3.12073959 C9.75909235,2.1870874 10.3529751,1.52753493 11.0981837,1.52753493 C11.9718766,1.52753493 12.4629719,2.17281137 12.5257865,3.12073959 L9.67058098,3.12073959 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8443562,0.08851137 C18.0047599,0.0643745126 17.2196538,0.502981268 16.8000291,1.23059356 L16.8000291,0.0770905481 L15.4295304,0.362611097 C15.1556997,0.391198178 14.9455507,0.618452433 14.9384351,0.893679317 L14.9384351,6.88961083 L16.785753,6.88961083 L16.785753,3.3862737 C16.785753,2.47546315 17.3425181,1.77879302 18.0877267,1.77879302 C18.9442884,1.77879302 19.2926235,2.43549028 19.2926235,3.23209261 L19.2926235,6.90388686 L21.1713487,6.90388686 L21.1713487,2.63820987 C21.1684935,1.0906885 20.3062214,0.08851137 18.8443562,0.08851137 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0593176,0.905100139 L22.0593176,6.90103166 L23.8409658,6.90103166 L23.8409658,0.0770905481 L22.5447025,0.362611097 C22.2736817,0.403518298 22.0699523,0.631215915 22.0593176,0.905100139 Z",
    id: "Path-2-3",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9810137,0.0770905481 C25.9823699,0.0770905481 24.7203691,1.61890151 24.7203691,3.66608384 C24.7203691,5.66472768 26.0080668,7.20082823 28.1666021,7.20082823 C28.8996863,7.22956205 29.6282226,7.07344712 30.2851646,6.74685056 C30.6334996,6.55269659 30.6477757,6.51272371 30.6477757,6.06160124 L30.6477757,5.0508585 C29.9579998,5.42444333 29.1879551,5.62528197 28.4035842,5.63617563 C27.6212579,5.63617563 26.7161577,5.18219795 26.6048047,4.20857288 L31.235948,4.20857288 C31.4072603,1.95867096 30.3222822,0.0770905481 27.9810137,0.0770905481 Z M26.5905287,3.1235948 C26.67904,2.19279781 27.2729228,1.53324535 28.0181314,1.53324535 C28.8918243,1.53324535 29.3829196,2.17852178 29.4457342,3.1235948 L26.5905287,3.1235948 Z",
    id: "Shape-2",
    fill: "url(#linearGradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TopIcon",
    transform: "translate(0, 0.5693)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0.688142293,
    y: 1.54641656,
    width: 1.89014603,
    height: 1.89014603
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49563025,7.59659698 C7.33791587,8.09340274 7.99746833,7.69652918 7.98890272,6.71433849 L7.98890272,1.10385971 C7.9803371,0.124524232 7.25797011,-0.283770152 6.41282929,0.210180396 L1.66747777,2.95403287 C0.810916129,3.442273 0.810916129,4.25029616 1.66747777,4.74710191 L6.50134066,7.6023074",
    id: "Fill-9",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.49331024,7.59659698 C0.636748594,8.09340274 -0.00567263979,7.69652918 0,6.71433849 L0,1.10385971 C0.00860338763,0.124524232 0.730970375,-0.283770152 1.5761112,0.210180396 L6.31860751,2.95403287 C7.17516915,3.442273 7.17516915,4.25029616 6.31860751,4.74710191 L1.49331024,7.59659698",
    id: "Fill-9-Copy",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31860751,2.95403287 L3.99732545,1.60637588 L1.66747777,2.95403287 C0.810916129,3.442273 0.810916129,4.25029616 1.66747777,4.74710191 L4.00303586,6.12331095 L6.33859395,4.74710191 C7.19515559,4.25029616 7.17802436,3.442273 6.33859395,2.95403287",
    id: "Fill-11",
    fill: "url(#linearGradient-8)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenie);
export default __webpack_public_path__ + "static/media/genie.019c143a3b5c7110ff85adc0ca03a987.svg";
export { ForwardRef as ReactComponent };